
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pid]/preview",
      function () {
        return require("private-next-pages/[pid]/preview/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pid]/preview"])
      });
    }
  